import { convertKeysToCamelCase } from '../../keysToCamelCase'
import { getMembership } from '../repositories/membershipRepository'

export default function getMembershipProperties() {
  return convertKeysToCamelCase(getMembership())
}
